export const userResourceType = "user" as const;
export const userResourcePath = "/users" as const;
export const userRequestResourceType = "user_request" as const;
